import { P } from "../../../components/Common/Typo/typo";

interface PageSelectionProps {
  selectedPage: number;
  pageList: {
    order: number;
    name: string;
  }[];
  onPageSelect: (pageOrder: number) => void;
}

const PageSelection = ({
  selectedPage,
  pageList,
  onPageSelect,
}: PageSelectionProps) => {
  return (
    <div className="flex items-center justify-center h-fit">
      {pageList.map((item) => (
        <div
          key={item.order}
          className="w-full border-b-2 px-[24px] py-[5px] cursor-pointer"
          style={{
            borderColor: selectedPage === item.order ? "#EC6B00" : "#1E9282",
            background:
              selectedPage === item.order
                ? "linear-gradient(0deg, #F4992A 0%, #FFF 227%)"
                : "linear-gradient(0deg, #1E9282 0%, #FFF 260%)",
          }}
          onClick={() => onPageSelect(item.order)}
        >
          <P
            fontSize="36px"
            fontWeight={selectedPage === item.order ? "700" : "400"}
            color="#FFF"
            className="text-center"
          >
            {item.name}
          </P>
        </div>
      ))}
    </div>
  );
};

export default PageSelection;
